import { actions } from './slice';
import { getPatientData } from './actions';

const allActions = {
  ...actions,
  getPatientData,
};

export { allActions as patientActions };
export { reducer as patientReducer } from './slice';
